exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".checkbox[data-v-3d1fd528] {\n  padding-bottom: 10px;\n}\n", ""]);

